import { render, staticRenderFns } from "./BadgeOrderAdmin.vue?vue&type=template&id=cc832186&scoped=true"
import script from "./BadgeOrderAdmin.vue?vue&type=script&lang=js"
export * from "./BadgeOrderAdmin.vue?vue&type=script&lang=js"
import style0 from "./BadgeOrderAdmin.vue?vue&type=style&index=0&id=cc832186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc832186",
  null
  
)

export default component.exports